import { connect } from 'react-redux';

import ModalBackground from 'components/general_panel/ModalBackground';

const mapStateToProps = state => ({
  isReportingError: state.reportError.get('isReportingError'),
});

const mapDispatchToProps = () => ({

});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalBackground);



// WEBPACK FOOTER //
// ./src/components/general_panel/containers/ModalBackgroundContainer.js